<template>
  <div ref="root" class="min-h-7 bg-primary border-b">
    <div
      class="container ui-text-xs text-white relative h-full text-center py-1.5"
      @click="contentClick"
      v-html="content"
    />
  </div>
</template>

<script setup lang="ts">
defineProps<{ content: string }>();

const root = ref();

const isVisibleDiscountCompaign = useElementVisibility(root);

const contentClick = useContentLink;

const { height } = useElementBounding(root);

watch(height, () => {
  setCustomProperty("--discount-compaign-height", String(`${height.value}px`));
});

watch(isVisibleDiscountCompaign, () => {
  setCustomProperty(
    "--discount-compaign-visible-height",
    String(isVisibleDiscountCompaign.value ? `${height.value}px` : "0px"),
  );
});
</script>
